import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { notification } from 'antd';

import { useAppSelector } from 'src/hooks';
import { AppI, CommonI } from 'src/redux';
import notifI18n from 'src/i18n/notifications.i18n.json';

// Protege rutas que necesitan una ciudad seleccionada (p. ej. la bolsa); si no hay, regresa a la landing
const RequireCity = ({ children }: { children: JSX.Element }) => {
   const { lang } = useAppSelector(({ app }: { app: AppI }) => app);
   const { currentZone } = useAppSelector(({ common }: { common: CommonI }) => common);

   useEffect(() => {
      if (!currentZone.locality) {
         // mismo aviso que el icono de la bolsa; el key evita duplicarlo
         notification.warning({
            key: 'city-required',
            message: notifI18n[lang].missingInfo,
            description: notifI18n[lang].cityRequired,
         });
      }
   }, [currentZone.locality]);

   if (!currentZone.locality) {
      return <Navigate to='/' replace />;
   }

   return children;
};

export default RequireCity;
